import React, { memo, useEffect, useState } from 'react';
import { useResponsiveBreakPoints } from '@restworld/utils-common';
export interface CircularProgressProps {
  /**
   * Progress in percent 0 - 100
   */
  progress: number;
  label?: string;
}

export const CircularProgressBar = memo(({ progress, label }: CircularProgressProps) => {
  // Ensure progress is between 0 and 100
  const [progressValue, setProgressValue] = useState<number>(0);
  const [progressLabel, setProgressLabel] = useState<string | number>('');
  const { isDesktop } = useResponsiveBreakPoints();
  const size = isDesktop ? 136 : 93;
  const radius = size / 2; // Half of the width/height of the circle
  const circumference = 2 * Math.PI * radius;
  const angle = (progressValue / 100) * 360;
  const dashOffset = circumference - (angle / 360) * circumference;

  useEffect(() => {
    setProgressValue(Math.min(Math.max(progress, 0), 100));
    if (label) {
      setProgressLabel(label);
    }
  }, [label, progress]);

  return (
    <div className="relative" style={{ width: size, height: size }}>
      <svg className="absolute inset-0" width={radius * 2} height={radius * 2}>
        <circle
          className="stroke-primary-100"
          cx={radius}
          cy={radius}
          r={radius - 4} // Adjust for stroke width
          strokeWidth="8"
          fill="transparent"
        />
        <circle
          className="stroke-primary-800"
          cx={radius}
          cy={radius}
          r={radius - 4} // Adjust for stroke width
          strokeWidth="8"
          fill="transparent"
          strokeDasharray={`${circumference} ${circumference}`}
          strokeDashoffset={dashOffset}
          transform={`rotate(-90 ${radius} ${radius})`} // Rotate to start from 0 degrees
          strokeLinecap="round"
        />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="lg:text-2xl text-base lg:leading-9 leading-6  text-black  font-semibold">{progressLabel}</div>
      </div>
    </div>
  );
});
